import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuthStore, useContextStore } from '../stores/storeRoot';

const InactivityTimerProvider: React.FC = () => {
  const location = useLocation();
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const { activeBpNumber } = useContextStore();
  const { logout, safeLogoutWithAcquireTokenSilent } = useAuthStore();
  // As CCM-1429 states, the inactivity timer should be set to 90 minutes
  // This is a temporary solution, in the future NZ might as to change it back to 30 minutes
  const MINUTES_TO_LOGOUT = 90;
  const logoutTime = MINUTES_TO_LOGOUT * 60 * 1000;
  const STORAGE_KEY = 'logoutAt'; // localStorage key

  // Resets the timer when the user is active
  const resetTimer = () => {
    //TODO@Piotr => remove console.log @25.10.2024
    console.log('InactivityTimerProvider: resetTimer invoked: ' + Date.now());
    const expireAt = Date.now() + logoutTime;
    localStorage.setItem(STORAGE_KEY, expireAt.toString());

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      //TODO@Piotr => remove console.log @25.10.2024
      console.log('InactivityTimerProvider: Logging-out: ' + Date.now());
      localStorage.removeItem(STORAGE_KEY);
      logout();
    }, logoutTime);
  };

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const expireAt = parseInt(stored, 10);
      if (Date.now() >= expireAt) {
        localStorage.removeItem(STORAGE_KEY);
        safeLogoutWithAcquireTokenSilent();
        return;
      }
    }
    // Starts the timer on URL load and resets on URL change
    resetTimer();
    // Cleans up the timers when the component is unmounted or URL changes
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
    //
  }, [location.pathname, activeBpNumber]);

  return null;
};

export default InactivityTimerProvider;
